import { render, staticRenderFns } from "./TechnicalPapers.vue?vue&type=template&id=4caa5878&"
import script from "./TechnicalPapers.vue?vue&type=script&lang=js&"
export * from "./TechnicalPapers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports